import { Inject, Pipe, PipeTransform } from 'ng-metadata/core';
import { DateRangeService } from './date-range.service'

/**
 * @ngdoc filter
 * @name mwDateRangeLastQuarter
 * @module mw.components.dateRange
 *
 * @param {Date} relativeDate - Relative date.
 * @param {string} [format] - Formatting rules (see momentjs formatting rules https://momentjs.com/docs/#/displaying/format/). If not specified, 'MMM D' is used.
 * @param {string} [timezone] - Timezone to be used for formatting the date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 * @param {string} [locale] - Locale used for formatting the date range.  If not specified, the browser locale will be used.
 *
 * @returns {string} Formatted date range string.
 *
 * @description
 * `mwLastQuarter` filter converts a relative `Date` object to a `DateRange` and formats it to a string.  Start Date will the beginning of the full quarter (Jan 1, Apr 1, Jul 1, Oct 1) prior to the current `relativeDate` input.  End Date will be the end of the full quarter (Jan 1, Apr 1, Jul 1, Oct 1) prior to the current `relativeDate` input.
 *
 */
@Pipe({ name: 'mwDateRangeLastQuarter' })
export class DateRangeLastQuarterPipe implements PipeTransform {
    private mwDateRangePipe;

    constructor(
        @Inject('mwDateRangeService') private dateRangeService: DateRangeService,
        @Inject('$filter') private $filter: any) {
        this.mwDateRangePipe = $filter('mwDateRange');
    }

    transform(date: Date, format: string, timezone: string, locale: string): string {
        return this.mwDateRangePipe(this.dateRangeService.lastQuarter(date, timezone), format, timezone, locale);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/date-range/date-range-last-quarter.pipe.ts